import { Injectable } from "@angular/core";
import { BaseModel } from "./base-model";
import { HttpService } from "../../services/http.service";
import { ConfigDocModelService } from "app/core/models/config-doc-model.service";
import { CourseTimerService } from "app/services/course-timer.service";

@Injectable()
export class OrientationModelService extends BaseModel {
	private language: string;
	public orientationXMLData: any;
	private audioPath: string;
	private arrTextfields: Array<any>;
	private arrHighLights: Array<any>;
	private objHStyle: any;
	private arrSteps: Array<any>;

	// For IE11 IntroJS
	public common: String;
	public commonStep: number;
	public navButtons: String;
	public navButtonsStep: number;
	public leftMenu: String;
	public leftMenuStep: number;
	public menuCollapse: String;
	public menuCollapseStep: number;
	public presentationMenu: String;
	public presentationMenuStep: number;
	public timerStep: number;
	public timer: String;
	public documentTab: String;
	public documentTabStep: number;
	public exitBtn: String;
	public exitBtnStep: number;
	public conclusion: String;
	public conclusionStep: number;
	public getDocdata: any;

	constructor(
		private httpService: HttpService,
		private configDocModel: ConfigDocModelService,
		private courseTimer: CourseTimerService
	) {
		super();
	}

	public initialize(language: any) {
		this.language = language;
		const orientationXMl = this.configDocModel.orientationXML(language);
		this.loadOrientationXML(orientationXMl);
	}
	private loadOrientationXML(url) {
		this.httpService.getXmlData(url).then((res: any) => {
			this.orientationXMLData = res;
			console.log(" this.orientationXMLData   :", this.orientationXMLData);
			this.parseOrientation();
			this._notifier.next("data");
		});
	}
	private parseOrientation() {
		this.audioPath = this.orientationXMLData.getElementsByTagName("audioClip")
			.length
			? this.orientationXMLData.getElementsByTagName("audioClip")[0].textContent
			: "";
		this.parseTextFields();
		this.parseHighlightStyle();
		this.createSteps();
	}
	private parseTextFields() {
		this.arrTextfields = [];
		const arrTextFields = Array.prototype.slice.call(
			this.orientationXMLData
				.getElementsByTagName("txtFields")[0]
				.getElementsByTagName("txtField")
		);
		arrTextFields.forEach((txtField) => {
			this.arrTextfields.push({
				id: txtField.getAttribute("id"),
				content: txtField.textContent,
			});
		});
	}

	private parseHighlightStyle() {
		const HSnode =
			this.orientationXMLData.getElementsByTagName("highlightStyle")[0];
		this.objHStyle = {};
		if(HSnode) {
		this.objHStyle.color = HSnode.getElementsByTagName("color")[0].textContent;
		this.objHStyle.borderSize =
			HSnode.getElementsByTagName("borderSize")[0].textContent;
		this.objHStyle.shape = HSnode.getElementsByTagName("shape")[0].textContent;
		}
	}
	private createSteps() {
		this.arrSteps = [];
		let timerIndex = this.arrTextfields.findIndex(step => step.id === "timer")
		// check if course timer and timer exists in xml
		if (!this.courseTimer.isCourseTimerAvailable && timerIndex > -1) {
			this.arrTextfields.splice(this.arrTextfields.findIndex(step => step.id === "timer") , 1)
		}
		for (let i = 0; i < this.arrTextfields.length; i++) {
			let step: any = {};
			step.index = i;
			step.id = i + 1;
			step.anchorId = this.arrTextfields[i].id;
			step.stepId = this.arrTextfields[i].id;
			step.content = this.arrTextfields[i].content;
			step.orphan = step.anchorId === "common" ? true : false;
			step.backdrop = true;
			switch (step.anchorId) {
				case "navButtons":
					step.placement = "top box_right_bottom w400";
					break;
				case "menuCollapse":
					step.placement = "right box_right_top "; //custom position
					break;
				case "leftMenu":
					step.placement = "bottom desktop_left "; //custom position
					break;
				case "documentTab":
					step.placement = "left"; //custom position
					step.containerClass = "box_left_top";
					break;
				case "exitBtn":
					step.placement = "left"; //custom position
					step.containerClass = "box_left_top";
					break;
				case "timer":
					step.placement = "left"; //custom position
					step.containerClass = "box_left_top";
					break;
				case "languageTab":
					step.placement = "left"; //custom position
					step.containerClass = "box_left_top";
					break;
				case "presentationMenu":
					//step.placement = (!this.configDocModel.isAdaptive)? 'bottom left mode_place':'bottom box_right_bottom p_modes_adaptive';
					step.placement = !this.configDocModel.isAdaptive
						? "bottom left mode_place"
						: "bottom  p_modes_adaptive";
					break;
				case "progressBar":
					step.placement = "bottom";
					break;
			}
			this.arrSteps.push(step);
		}
		this.updateSteps();
	}
	private updateSteps() { // update steps  array as per Languages and Custom Docs
		const languageTabStep: any = this.arrSteps.find(
			(step) => step.anchorId === "languageTab"
		);
		const documentTabStep: any = this.arrSteps.find(
			(step) => step.anchorId === "documentTab"
		);
		if (
			this.configDocModel.availableLanguages.length === 1 &&
			languageTabStep
		) {
			this.arrSteps.splice(languageTabStep.index, 1);
		}
		if (
			this.configDocModel.getCustomDocsForLanguage(this.language).length ===
				0 &&
			documentTabStep
		) {
			this.arrSteps.splice(documentTabStep.index, 1);
		}
		// For IE11 IntroJS
		this.commonStep = this.arrSteps.find((step) => step.anchorId === "common")
			? this.arrSteps.find((step) => step.anchorId === "common").id
			: "";
			this.common = this.arrSteps.find(step => step.anchorId === 'common') 
			? this.arrSteps.find(step => step.anchorId === 'common').content
			: "";
		this.navButtonsStep = this.arrSteps.find(
			(step) => step.anchorId === "navButtons"
		)
			? this.arrSteps.find((step) => step.anchorId === "navButtons").id
			: "";
		this.navButtons = this.arrSteps.find(
			(step) => step.anchorId === "navButtons"
		)
			? this.arrSteps.find((step) => step.anchorId === "navButtons").content
			: "";
		this.leftMenuStep = this.arrSteps.find(
			(step) => step.anchorId === "leftMenu"
		)
			? this.arrSteps.find((step) => step.anchorId === "leftMenu").id
			: "";
		this.leftMenu = this.arrSteps.find((step) => step.anchorId === "leftMenu")
			? this.arrSteps.find((step) => step.anchorId === "leftMenu").content
			: "";
		this.timerStep = this.arrSteps.find(
			(step) => step.anchorId === "timer"
		)
			? this.arrSteps.find((step) => step.anchorId === "timer").id
			: "";
		this.timer= this.arrSteps.find((step) => step.anchorId === "timer")
			? this.arrSteps.find((step) => step.anchorId === "timer").content
			: "";
		this.menuCollapseStep = this.arrSteps.find(
			(step) => step.anchorId === "menuCollapse"
		)
			? this.arrSteps.find((step) => step.anchorId === "menuCollapse").id
			: "";
		this.menuCollapse = this.arrSteps.find(
			(step) => step.anchorId === "menuCollapse"
		)
			? this.arrSteps.find((step) => step.anchorId === "menuCollapse").content
			: "";
		this.presentationMenuStep = this.arrSteps.find(
			(step) => step.anchorId === "presentationMenu"
		)
			? this.arrSteps.find((step) => step.anchorId === "presentationMenu").id
			: "";
		this.presentationMenu = this.arrSteps.find(
			(step) => step.anchorId === "presentationMenu"
		)
			? this.arrSteps.find((step) => step.anchorId === "presentationMenu")
					.content
			: "";
		this.documentTabStep = this.arrSteps.find(
			(step) => step.anchorId === "documentTab"
		)
			? this.arrSteps.find((step) => step.anchorId === "documentTab").id
			: "";
		this.documentTab = this.arrSteps.find(
			(step) => step.anchorId === "documentTab"
		)
			? this.arrSteps.find((step) => step.anchorId === "documentTab").content
			: "";
		this.exitBtnStep = this.arrSteps.find((step) => step.anchorId === "exitBtn")
			? this.arrSteps.find((step) => step.anchorId === "exitBtn").id
			: "";
		this.exitBtn = this.arrSteps.find((step) => step.anchorId === "exitBtn")
			? this.arrSteps.find((step) => step.anchorId === "exitBtn").content
			: "";
		this.conclusionStep = this.arrSteps[this.arrSteps.length - 1].id;
		this.conclusion = this.arrSteps[this.arrSteps.length - 1].content;
		this.getDocdata =
			this.configDocModel.getCustomDocsForLanguage(this.language).length === 0;
	}

	public get steps(): Array<any> {
		return this.arrSteps;
	}

	public get heightLights(): Array<any> {
		return this.arrTextfields;
	}
	public get textFields(): Array<any> {
		return this.arrTextfields;
	}
	public get hStyle(): any {
		return this.objHStyle;
	}
}
